import Axios from 'axios';
import classNames from 'classnames';
import { addHours, format, parse } from 'date-fns';
import { addLocale, locale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Tag } from "primereact/tag";
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { mask, unMask } from 'remask';
import { Api } from '../../../../services/api';
import { formatCurrency } from '../../../../utils/formatCurrency';
//import DetalhesDialog from './AddNegotiationDialogs/DetalhesDialog';
import { Controller, useForm } from 'react-hook-form';
import { FaArrowAltCircleRight, FaCalendarAlt, FaCheck, FaInfoCircle, FaSearch, FaTimes } from 'react-icons/fa';
import AppCard from '../../../../components/appCard';
import DetalhesDialog from '../../../../components/dashboard/inadimplencias/gerar/detalhesDialog';
import { useInfo } from '../../../../context/infoContext';
import { associado_id, userInfo } from '../../../../services/authHandlers';
import { CalendarPague, DropdownPague, InputNumberPague, LargeTablePague } from '../../../../styles/primeReactConfig';
import { NewClassesDialog } from '../../../../components/dashboard/inadimplencias/importacao/newClasseDialog';
import { ClassesDialog } from '../../../../components/dashboard/inadimplencias/importacao/classesDialog';


export const AddNegotiation = () => {

  const { control, register, handleSubmit, setValue, reset, resetField, watch } = useForm({
    defaultValues: {
      cobranca_descricao: '',
      cobranca_valor: null,
      usuario_nome: '',
      usuario_documento: '',
      usuario_email: '',
      usuario_telefone: '',
      usuario_data_nascimento: null,
      endereco_rua: '',
      endereco_numero: null,
      endereco_complemento: '',
      endereco_bairro: '',
      endereco_cidade: '',
      endereco_estado: '',
      endereco_cep: '',
      cobranca_boleto_parcela: null,
      cobranca_numero_cliente_credor: '',
      cobranca_id_externo: '',
      vencimento: null,
      pc_juros: null,
      pc_multa: null,
      classe_cobranca_id: null
    }
  });
  const navigate = useNavigate();
  const cobranca_id_detalhe = useRef('')
  const regex = /[!@#$%^&()_={}\]:;,.<>+?0-9]/;
  const { credorData, missingBank } = useInfo()
  const [logInfo, setLogInfo] = useState([])
  const [selectedFilter, setSelectedFilter] = useState('');
  const [associados, setAssociados] = useState([]);
  const [multipleDevedores, setMultipleDevedores] = useState(false);
  const [showDetalhe, setShowDetalhe] = useState(false);
  const [showMultiple, setShowMultiple] = useState(false)
  const [cobrancaID, setCobrancaID] = useState('')
  const [] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadLog, setLoadLog] = useState(false);
  const [reload, setReload] = useState(false);
  const [count, setCount] = useState(0)
  const rows = useRef(10);
  const first = useRef(0)
  const page = useRef(0);
  const searchState = useRef(null)
  const opcoesFiltro = [
    { label: "Data Geração", value: "data" },
    { label: "Documento", value: "documento" },
    //{ label: "Nome Associado", value: "associado_nome" },
  ];
  const [filtroSelecionado, setFiltroSelecionado] = useState("documento")
  const [filtroParametro, setFiltroParametro] = useState('')
  const today = new Date();
  const minimo = new Date("1900-01-01T00:00:00");

  //Sets upload imagem
  const [negociacaoArquivoPDF, setNegociacaoArquivoPDF] = useState(null)
  const [totalSize, setTotalSize] = useState(0);
  
  const [showNewClasses, setShowNewClasses] = useState(false);
  const [classesOptions, setClassesOptions] = useState([]);

  addLocale('pt-BR', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'Hoje',
    clear: 'Claro'
  });
  locale('pt-BR');

  useEffect(() => {
    async function consultaLog() {
      try {
        setLoadLog(true)
        const { data } = await Api.get(`cobranca/log_cobrancas/${rows.current}/${page.current}`)
        setLogInfo(data.log_cobrancas)
        setCount(data.count)
      } catch (error) {
        if (error && error.response)
          console.log(error.response)
      } finally {
        setLoadLog(false)
      }
    }
    async function consultaLogFiltro() {
      let parametro = unMask(filtroParametro)
      //console.log(filtroParametro)
      if (filtroSelecionado === 'data')
        parametro = format(parse(filtroParametro, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd')
      try {
        setLoadLog(true)
        const { data } = await Api.get(`cobranca/log_cobrancas/${rows.current}/${page.current}?filtro=${filtroSelecionado}&parametro=${parametro}`)
        setLogInfo(data.log_cobrancas)
        setCount(data.count)
      } catch (error) {
        if (error && error.response)
          console.log(error.response)
      } finally {
        setLoadLog(false)
      }
    }
    async function fetchClasses() {
      try {
        const { data } = await Api.get(`cargacobrancas/classeCobranca`)
        if (data) {
          const classesAtivas = data.classes.filter((item) => item.classe_cobranca_status === true)
          classesAtivas.push({
            classe_descricao: 'SEM CLASSE',
            classe_cobranca_id: null
          })
          setClassesOptions(classesAtivas.map(item => {
            return {
              label: String(item.classe_descricao).toUpperCase(),
              value: item.classe_cobranca_id
            }
          }));
        }
      } catch (error) {
        console.log(error)
      }
    }
    fetchClasses()
    if (searchState.current)
      consultaLogFiltro()
    else
      consultaLog()
  }, [reload])

  function onPage(event) {
    first.current = event.first;
    rows.current = event.rows;
    page.current = event.page;
    setReload(prevReload => !prevReload)
  }

  const handleSelection = (e) => {
    cobranca_id_detalhe.current = e.value.cobranca_id;
    //console.log(e.value, cobranca_id_detalhe)
    setShowDetalhe(true)
  }


  const filterOptions = [
    { label: credorData.credor_nome, value: [0, credorData.credor_id] },
    { label: credorData.usuario_nome, value: [1, credorData.usuario_gestor_id] },
  ];

  const createNegotiation = async (e) => {
    setLoading(true)
    try {
      const { data } = await Api.post('/cobranca/create', e);
      setCobrancaID(data.cobranca_id);
      setReload(prevReload => !prevReload)
      toast.success("Negociação gerada com sucesso");
      confirmDialog({
        message: "Cobrança cadastrada! Deseja adicionar mais devedores a esta cobrança",
        header: "Multiplos Devedores",
        icon: "pi pi-circle-info",
        acceptClassName: "outline-green-500 hover:outline-green-600 outline-2 outline bg-green-500 hover:bg-green-600 rounded-md w-full py-3 text-white transition duration-300",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => addMultipleDevedores(),
        reject: () => limpaForm(),
      })
    } catch (error) {
      console.log(error.response);
      if (error.response) {
        if (error.response.status === 403)
          toast.error("Cobrança duplicada! cobrança com o mesmo valor, vencimento e descrição já cadastrada para esse devedor");
        if (error.response.status === 500)
          toast.error("Erro ao criar cobrança")
      } else
        toast.error("Erro de comunicação com o servidor");
    } finally {
      setLoading(false)
    }
  }

  const createMultipleNegotiation = async () => {
    const negotiationData = {
      associados: associados,
      cobranca_id: cobrancaID,
      cobranca_numero_cliente_credor: watch("cobranca_numero_cliente_credor"),
    }
    setLoading(true)
    try {
      await Api.post('/cobrancaassociado', negotiationData);
      setReload(prevReload => !prevReload)
      toast.success('Devedores adicionados com sucesso!');
      addMultipleDevedores();
      resetField("cobranca_descricao");
      resetField("cobranca_valor");
      resetField("cobranca_boleto_parcela");
      resetField("pc_juros");
      resetField("pc_multa");
      resetField("vencimento");
      resetField("classe_cobranca_id");
      resetField("cobranca_numero_cliente_credor");
      resetField("NegotiationTime");
    } catch (error) {
      console.log(error.response);
      toast.error('Erro ao adicionar devedor a negociação.');
    } finally {
      setLoading(false)
    }
  }

  const consultaCEP = async (e) => {
    try {
      const { data } = await Axios.get(`https://viacep.com.br/ws/${mask(e, '99999-999')}/json/`);
      if (data.erro === true) {
        toast.error("CEP não encontrado")
        setValue("endereco_estado", "");
        setValue("endereco_cidade", "");
        setValue("endereco_rua", "");
        setValue("endereco_bairro", "");
      } else {
        setValue("endereco_estado", data.uf);
        setValue("endereco_cidade", data.localidade);
        setValue("endereco_rua", data.logradouro);
        setValue("endereco_bairro", data.bairro);
        setValue("endereco_numero", 0);
        setValue("endereco_complemento", '');
        toast.success("CEP encontrado");
      }
    } catch (error) {
      console.log(error.response)
      toast.error('Serviço de verificação de CEP indisponível')
    }
  }

  const consultaCPF = async (e) => {

    try {
      const { data } = await Api.get(`users/user/${unMask(e, ['999.999.999-99', '99.999.999/9999-99'])}`)
      if (data) {

        setValue("usuario_nome", data.usuario_nome);
        setValue("usuario_data_nascimento", addHours(new Date(data.usuario_data_nascimento), 3));
        setValue("usuario_email", data.usuario_email);
        setValue("usuario_telefone", mask(data.usuario_telefone, ['(99) 9999-9999', '(99) 99999-9999']));
        setValue("endereco_cep", mask(data.enderecos[0].endereco_cep, '99999-999'));
        setValue("endereco_estado", data.enderecos[0].endereco_estado);
        setValue("endereco_cidade", data.enderecos[0].endereco_cidade);
        setValue("endereco_rua", data.enderecos[0].endereco_rua);
        setValue("endereco_bairro", data.enderecos[0].endereco_bairro);
        setValue("endereco_numero", Number(data.enderecos[0].endereco_numero))
        setValue("endereco_complemento", data.enderecos[0].endereco_complemento)
        toast.success("Usuário encontrado")
      } else
        toast.warning("Nenhum usuário encontrado")
    } catch (error) {
      console.log(error.response)
      toast.warning("Nenhum usuário encontrado")
    }
  }

  function checkComplete(e) {
    if (e.length === 14 || e.length === 20 || e.length === 18)
      return consultaCPF(e);
  }

  const itemTemplate = (file, props) => {
    const onTemplateRemove = (file, callback) => {
      setTotalSize(totalSize - file.size);
      callback();
    };
    return (
      <div className="grid w-full mt-1">
        <div className=''>
          <div className="flex text-left">
            <b>{file.name}</b>
          </div>
          <div className='flex justify-content-between align-items-center mt-3'>
            <img
              alt={file.name}
              role="presentation"
              src={"https://play-lh.googleusercontent.com/9XKD5S7rwQ6FiPXSyp9SzLXfIue88ntf9sJ9K250IuHTL7pmn2-ZB0sngAX4A2Bw4w"}
              width={85}
            />
            <Tag
              className="w-3"
              value={props.formatSize}
              severity="warning"
              style={{ maxHeight: 30 }}
            />
            <Button
              severity="danger"
              className="w-6/12"
              onClick={() => onTemplateRemove(file, props.onRemove)}
              type="button"
              icon={<FaTimes />}
              style={{ minWidth: "2rem", maxHeight: "2rem" }}
              outlined
              rounded
            />
          </div>
        </div>
      </div>
    );
  };


  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result);
      }
      fileReader.onerror = (error) => {
        reject(error);
      }
    })
  }

  async function uploadImagem(e) {
    const filePDF = e.files[0]
    const limparImagem = e.options.clear


    if (e.files.length > 1) {
      toast.error('Insira apenas um arquivo')
      limparImagem()
      return;
    }


    if (filePDF.type.indexOf('/pdf') === -1) {
      toast.error('Insira um arquivo PDF.')
      limparImagem();
      return;
    }

    const base64 = await convertBase64(filePDF)

    const leitor = new FileReader();

    leitor.readAsDataURL(filePDF);
    leitor.onload = function () {
      setNegociacaoArquivoPDF(base64)
      return true;
    };
  }


  function addMultipleDevedores() {
    setMultipleDevedores(true);
    resetField("usuario_documento");
    resetField("usuario_nome");
    resetField("usuario_data_nascimento");
    resetField("usuario_email");
    resetField("usuario_telefone");
    resetField("endereco_cep");
    resetField("endereco_estado");
    resetField("endereco_cidade");
    resetField("endereco_rua");
    resetField("endereco_bairro");
    resetField("endereco_numero");
    resetField("endereco_complemento");
  }

  function deleteDevedor(e) {
    const devedor_nome = associados.map((e) => {
      return e.usuario_nome
    });
    const index = devedor_nome.indexOf(e);
    const remove = associados;
    if (index !== -1)
      remove.splice(index, 1)
    setAssociados(remove);
  }

  function addNewDevedor(values) {
    setAssociados(prevAssociados => prevAssociados.concat(
      {
        usuario_nome: values.usuario_nome,
        usuario_documento: unMask(values.usuario_documento),
        usuario_email: values.usuario_email,
        usuario_telefone: unMask(values.usuario_telefone),
        usuario_data_nascimento: format(values.usuario_data_nascimento, "yyyy-MM-dd"),
        endereco_rua: values.endereco_rua,
        endereco_numero: values.endereco_numero.toString(),
        endereco_complemento: values.endereco_complemento,
        endereco_bairro: values.endereco_bairro,
        endereco_cidade: values.endereco_cidade,
        endereco_estado: values.endereco_estado,
        endereco_cep: unMask(values.endereco_cep),
      }))
    //setShowMultiple(true);
  }


  function limpaForm() {
    reset()
  }

  const onSubmit = (values) => {
    // event.preventDefault();
    //console.log(values)
    let categoria = 'Inadimplencia';

    const negotiationData =
    {
      ...values,
      pc_tempo_negociacao: null,
      associado_id: associado_id,
      endereco_cep: unMask(values.endereco_cep),
      usuario_documento: unMask(values.usuario_documento),
      usuario_telefone: unMask(values.usuario_telefone),
      usuario_data_nascimento: format(values.usuario_data_nascimento, "yyyy-MM-dd"),
      endereco_numero: values.endereco_numero.toString(),
      cobranca_boleto_parcela: values.numero_parcelas.toString(),
      vencimento: format(values.vencimento, "yyyy-MM-dd"),
      pc_juros: Number(values.pc_juros),
      pc_multa: Number(values.pc_multa),
      pc_desconto: 0,
      credor_id: credorData.credor_id,
      gestor_id: credorData.gestor_id,
      usuario_gestor_id: selectedFilter[1],
      boleto_base64: negociacaoArquivoPDF
    }

    //console.log(negotiationData)
    if (values.vencimento < today && categoria === 'Adimplencia')
      toast.warning("Você está tentando cadastrar uma cobrança que já venceu como adimplente! Verifique a data de vencimento informada")
    if (values.vencimento > today && categoria === "Inadimplencia")
      toast.warning("Você está tentado cadastrar uma cobrança que ainda não venceu como inadimplente! Verifique a data de vencimento informada")
    if ((values.vencimento > today && categoria === 'Adimplencia') || (values.vencimento < today && categoria === "Inadimplencia")) {
      if (!multipleDevedores) {
        createNegotiation(negotiationData);
      } else {
        addNewDevedor(values);
      }
    }
  }

  function handleSearch(e) {
    if (e === 13) {
      searchState.current = true
      setReload(prevReload => !prevReload)
    }
  }

  const header = (
    <div className="grid">
      <div className='grid md:flex gap-2'>
        <div className="flex">
          <Dropdown
            value={filtroSelecionado}
            options={opcoesFiltro}
            pt={DropdownPague}
            onChange={(e) => {
              setFiltroSelecionado(e.value);
              setFiltroParametro(null);
            }}
          ></Dropdown>
          {/* <i className="pi pi-search"></i> */}
        </div>
        {filtroSelecionado === "documento" && <InputText value={filtroParametro} onChange={(e) => setFiltroParametro(mask(unMask(e.target.value), ["999.999.999-99", "99.999.999/9999-99"]))} placeholder="Busca por CPF/CNPJ devedor" onKeyDown={(e) => handleSearch(e.keyCode)} />}
        {filtroSelecionado === "associado_nome" && <InputText value={filtroParametro} onChange={(e) => setFiltroParametro(e.target.value)} placeholder="Busca por Nome do Associado Responsável" onKeyDown={(e) => handleSearch(e.keyCode)} />}
        {filtroSelecionado === "data" && <InputText value={filtroParametro} onChange={(e) => setFiltroParametro(mask(unMask(e.target.value), "99/99/9999"))} placeholder="Busca por Data de Geração" onKeyDown={(e) => handleSearch(e.keyCode)} />}
        <div className='flex gap-2'>
          <Button
            onClick={() => handleSearch(13)}
            icon={<FaSearch className='text-xl' />}
            pt={{
              root: `bg-pague_verde_claro hover:bg-pague_verde border-0
                          dark:bg-pague_verde dark:hover:bg-pague_verde_claro
                          p-4 rounded-lg text-white dark:text-black`,
              label: "absolute"
            }} />
          <Button
            icon={<FaTimes className='text-2xl' />}
            pt={{
              root: `bg-red-500 hover:bg-red-600 border-0
                dark:bg-red-500 dark:hover:bg-red-400
                p-3 rounded-lg text-white dark:text-black`,
              label: "absolute"
            }}
            onClick={() => {
              //console.log(filtroParametro)
              setFiltroParametro("");
              searchState.current = false
              setReload(prevReload => !prevReload)
            }}
          />
        </div>
      </div>
    </div>
  )

  return (
    <>
      {showDetalhe &&
        <DetalhesDialog cobranca_id={cobranca_id_detalhe.current} close={() => setShowDetalhe(false)} />}
      {showNewClasses &&
        <NewClassesDialog
          classes={classesOptions}
          close={() => setShowNewClasses(false)}
          reload={() => setReload(prevReload => !prevReload)}
        />
      }
      <ConfirmDialog
        visible={showMultiple}
        header="Multiplos devedores"
        onHide={() => setShowMultiple(false)}
        message="Devedor adicionado! deseja adicionar mais um devedor à cobrança?"
        acceptClassName="outline-green-500 hover:outline-green-600 outline-2 outline bg-green-500 hover:bg-green-600 rounded-md w-full py-3 text-white transition duration-300"
        rejectClassName="outline-red-500 outline-2 outline rounded-md w-full py-3 text-red-500 hover:bg-red-500 hover:text-white transition duration-300"
        acceptLabel="Adicionar mais devedores"
        rejectLabel="Finalizar negociação"
        acceptIcon={<FaCheck />}
        rejectIcon={<FaTimes />}
        accept={() => addMultipleDevedores()}
        reject={() => createMultipleNegotiation()}
      />
      {!missingBank
        || userInfo.usuario_id === '5de3ccb0-b448-404b-ad3f-18df8af0e1ed'
        ?
        <div className='w-full grid gap-4'>
          <AppCard className="w-full">
            <form onSubmit={handleSubmit(onSubmit)} className='w-full'>
              {/* <h4><b>Gerar Cobrança</b></h4> */}
              <div className="flex-wrap flex w-full">
                <div className="w-full lg:w-1/2 p-2">
                  <div className={`rounded-lg p-2 border-solid border-2 border-blue-800
                    dark:bg-sky-900 bg-slate-200 w-full`}>
                    <h5 className="mb-6 text-2xl"><b>Dados da Inadimplência</b></h5>
                    {credorData.usuario_gestor_id &&
                      <div className='mb-1' style={{ marginTop: '-2rem' }}>
                        <label htmlFor="gerado_por">Gerado por</label>
                        <Dropdown
                          id='gerado_por'
                          pt={DropdownPague}
                          value={selectedFilter}
                          options={filterOptions}
                          className='w-12'
                          onChange={(e) => {
                            setSelectedFilter(e.value);
                            setNegociacaoArquivoPDF(null)
                          }}
                          required={false}
                        />
                      </div>
                    }
                    <div className="grid xl:flex w-full">
                      <div className="grid w-full xl:w-1/2">
                        <div className="w-full grid p-1">
                          <label htmlFor="cobranca_numero_cliente_credor">Código do Cliente</label>
                          <InputText
                            {...register("cobranca_numero_cliente_credor", {
                              required: true,
                            })}
                            placeholder="ex: 9999"
                            disabled={multipleDevedores}
                          />
                        </div>

                        <div className="w-full grid p-1">
                          <label htmlFor="cobranca_descricao">Descrição</label>
                          <InputText
                            {...register("cobranca_descricao", {
                              required: true,
                            })}
                            placeholder="ex: 9999"
                            disabled={multipleDevedores}
                          />
                        </div>

                        <div className="w-full grid p-1">
                          <label htmlFor="cobranca_valor">Valor original</label>
                          <Controller
                            control={control}
                            defaultValue={null}
                            rules={{ required: true }}
                            render={({ field: { onChange, onBlur, value, name } }) => (
                              <InputNumber
                                value={value}
                                onValueChange={(e) => { onChange(e) }}
                                onBlur={onBlur}
                                pt={InputNumberPague}
                                id={name}
                                mode='currency'
                                locale='pt-BR'
                                currency='BRL'
                                placeholder='R$ 150,00'
                              />
                            )}
                            name="cobranca_valor"
                          />
                        </div>

                        <div className="w-full grid p-1">
                          <label htmlFor="pc_juros">Juros/Mês</label>
                          <Controller
                            control={control}
                            defaultValue={null}
                            rules={{ required: true }}
                            render={({ field: { onChange, onBlur, value, name } }) => (
                              <InputNumber
                                onValueChange={(e) => onChange(e)}
                                placeholder="ex: % 1"
                                value={value}
                                onBlur={onBlur}
                                disabled={multipleDevedores}
                                pt={InputNumberPague}
                                id={name}
                                maxFractionDigits={4}
                                prefix="% "
                                min={0}
                                max={100}
                              />
                            )}
                            name="pc_juros"
                          />
                        </div>

                        {classesOptions.length > 0 &&
                          <div className="w-full grid p-1">
                            <label htmlFor="classe_cobranca_id">Classe de Cobrança</label>
                            <Controller
                              name="classe_cobranca_id"
                              control={control}
                              defaultValue={null}
                              rules={{ required: false }}
                              render={({ field: { onChange, onBlur, value, name } }) => (
                                <Dropdown
                                  className="w-full"
                                  pt={DropdownPague}
                                  value={value}
                                  id={name}
                                  options={classesOptions}
                                  onChange={(e) => {
                                    onChange(e.value);
                                  }}
                                />
                              )}
                            />
                          </div>
                        }

                      </div>
                      <div className="grid w-full xl:w-1/2 content-start">
                        <div className="w-full grid p-1">
                          <label htmlFor="pc_multa">Multa</label>
                          <Controller
                            name="pc_multa"
                            control={control}
                            defaultValue={null}
                            rules={{ required: true }}
                            render={({ field: { onChange, onBlur, value, name } }) => (
                              <InputNumber
                                onValueChange={(e) => onChange(e)}
                                value={value}
                                onBlur={onBlur}
                                placeholder="ex: % 5"
                                disabled={multipleDevedores}
                                id={name}
                                pt={InputNumberPague}
                                maxFractionDigits={4}
                                prefix="% "
                                min={0}
                                max={100}
                              />
                            )}
                          />
                        </div>

                        <div className="w-full grid p-1">
                          <label htmlFor="vencimento">Data de Vencimento</label>
                          <Controller
                            name="vencimento"
                            control={control}
                            defaultValue={null}
                            rules={{ required: true }}
                            render={({ field: { onChange, onBlur, value } }) => (
                              <Calendar
                                value={value}
                                onChange={e => onChange(e)}
                                onBlur={onBlur}
                                min={minimo}
                                pt={CalendarPague}
                                locale="pt-BR"
                                dateFormat="dd/mm/yy"
                                disabled={multipleDevedores}
                                placeholder="ex: 25/05/2019"
                                yearRange="2000:2030"
                                showOnFocus={false}
                                icon={<FaCalendarAlt className={
                                  classNames('px-4 rounded-r-lg',
                                    'w-[50px] h-full',
                                    'bg-sky-400 text-white hover:bg-sky-500',
                                    'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                                  )}
                                />}
                                yearNavigator
                                mask="99/99/9999"
                                id="vencimento"
                              />)}
                          />
                        </div>

                        <div className="w-full grid p-1">
                          <label htmlFor="parcelas">Parcelas</label>
                          <Controller
                            name="numero_parcelas"
                            control={control}
                            defaultValue={null}
                            rules={{ required: true }}
                            render={({ field: { onChange, onBlur, value, name } }) => (
                              <InputNumber
                                value={value}
                                onValueChange={(e) => { onChange(e) }} //console.log(value) }}
                                onBlur={onBlur}
                                placeholder="ex: 7x"
                                id={name}
                                pt={InputNumberPague}
                                disabled={multipleDevedores}
                                suffix="x"
                                min={0}
                              />)}
                          />
                        </div>

                        <div className="w-full grid p-1">
                          <label htmlFor="cobranca_id_externo">Código do Débito</label>
                          <InputText
                            {...register("cobranca_id_externo", {
                              required: false,
                            })}
                            placeholder="ex: 232000"
                            id="cobranca_id_externo"
                            disabled={multipleDevedores}
                          />
                        </div>

                      </div>
                    </div>
                    {selectedFilter[0] === 1 && (
                      <div className="grid" style={{ marginTop: '-2rem' }}>
                        <div className="align-items-center justify-content-center boleto-load-img">
                          <label htmlFor="carrega_pdf" className='mt-2 mb-2'>Adicionar pdf</label>
                          <FileUpload
                            id="carrega_pdf"
                            name="file"
                            chooseLabel="Carregar PDF"
                            accept='application/pdf'
                            auto
                            customUpload
                            uploadHandler={uploadImagem}
                            itemTemplate={itemTemplate}
                            // onRemove={() => setLancamentoImagem({})}
                            // maxFileSize={TRES_MB_EM_BYTES}
                            invalidFileSizeMessageSummary="Tamanho inválido"
                            invalidFileSizeMessageDetail='Sua imagem passou o limite de 3MB'
                          />
                          <label htmlFor="lancamento_imagem" className='mt-2 mb-2'>
                            <b style={{ fontSize: 12 }}>( Somente PDF || Tamanho maximo 3Mb )</b>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-1/2 p-2">
                  <div className={`rounded-lg p-2 border-solid border-2 border-blue-800
                    dark:bg-sky-900 bg-slate-200`}>
                    <h5 className="mb-6 text-2xl"><b>Dados do Inadimplente</b></h5>
                    <div className="grid xl:flex w-full">
                      <div className="inline w-full xl:w-1/2">
                        <div className="w-full grid p-1">
                          <label htmlFor="usuario_documento">CPF/CNPJ</label>
                          <Controller
                            name="usuario_documento"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <InputText
                                value={value}
                                onChange={({ target }) => {
                                  onChange(
                                    mask(unMask(target.value), [
                                      '999.999.999-99',
                                      '99.999.999/9999-99'
                                    ])
                                  );
                                  checkComplete(target.value)
                                }}
                                placeholder="ex: 999.999.999-99"
                                id="usuario_documento"
                              />)}
                          />
                        </div>

                        <div className="w-full grid p-1">
                          <label htmlFor="usuario_nome">Nome</label>
                          <InputText
                            {...register("usuario_nome", {
                              required: true,
                              setValueAs: e => e.replace(regex, '')
                            })}
                            placeholder="ex: José Santos"
                            id="usuario_nome"
                          //type="text"
                          />
                        </div>

                        <div className="w-full grid p-1">
                          <label htmlFor="usuario_data_nascimento">Data de Nascimento/Criação</label>
                          <Controller
                            name="usuario_data_nascimento"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <Calendar
                                value={value}
                                min={minimo}
                                maxDate={today}
                                pt={CalendarPague}
                                locale="pt-BR"
                                dateFormat="dd/mm/yy"
                                onChange={(e) => onChange(e.target.value)}
                                placeholder="ex: 21/06/1992"
                                yearRange="1900:2030"
                                showOnFocus={false}
                                showIcon
                                icon={<FaCalendarAlt className={
                                  classNames('px-4 rounded-r-lg',
                                    'w-[50px] h-full',
                                    'bg-sky-400 text-white hover:bg-sky-500',
                                    'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                                  )}
                                />}
                                id="usuario_data_nascimento"
                                mask="99/99/9999"
                              />)}
                          />
                        </div>

                        <div className="w-full grid p-1">
                          <label htmlFor="usuario_email">E-mail</label>
                          <InputText
                            {...register("usuario_email", {
                              required: true,
                            })}
                            placeholder="ex: jose123@gmail.com"
                            id="usuario_email"
                            type="email"
                          />
                        </div>

                        <div className="w-full grid p-1">
                          <label htmlFor="usuario_telefone">Contato</label>
                          <Controller
                            name="usuario_telefone"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <InputText
                                value={value}
                                onChange={({ target }) =>
                                  onChange(
                                    mask(unMask(target.value), [
                                      //'(99) 9999-9999',
                                      '(99) 99999-9999'
                                    ])
                                  )
                                }
                                placeholder="ex: (99) 99999-9999"
                                id="usuario_telefone"
                                type="text"
                              />)}
                          />
                        </div>

                      </div>
                      <div className="inline w-full xl:w-1/2">

                        <div className='grid w-full p-1'>
                          <label htmlFor="endereco_cep">CEP</label>
                          <Controller
                            name="endereco_cep"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <InputMask
                                value={value}
                                onChange={(e) => onChange(e.target.value)}
                                onComplete={(e) => consultaCEP(e.value)}
                                placeholder="ex: 99999-999"
                                id="endereco_cep"
                                mask="99999-999"
                              />)}
                          />
                        </div>

                        <div className='grid w-full p-1'>
                          <label htmlFor="endereco_estado">Estado</label>
                          <Controller
                            name="endereco_estado"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <InputMask
                                value={value}
                                onChange={(e) => onChange(e.target.value)}
                                id="endereco_estado"
                                placeholder="ex: PA"
                                type="text"
                                mask="aa"
                              />)}
                          />
                        </div>

                        <div className='grid w-full p-1'>
                          <label htmlFor="endereco_cidade">Cidade</label>
                          <InputText
                            {...register("endereco_cidade", {
                              required: true
                            })}
                            placeholder="ex: Belém"
                            id="endereco_cidade"
                            type="text"
                          />
                        </div>

                        <div className='grid w-full p-1'>
                          <label htmlFor="endereco_rua">Rua</label>
                          <InputText
                            {...register("endereco_rua")}
                            placeholder="ex: Av Almirante Barroso"
                            id="endereco_rua"
                            type="text"
                          />
                        </div>

                        <div className='grid w-full p-1'>
                          <label htmlFor="endereco_bairro">Bairro</label>
                          <InputText
                            {...register("endereco_bairro")}
                            placeholder="ex: Souza"
                            id="endereco_bairro"
                            type="text"
                          />
                        </div>

                        <div className='grid w-full p-1'>
                          <label htmlFor="numero">Número</label>
                          <Controller
                            name="endereco_numero"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, onBlur, value } }) => (
                              <InputNumber
                                value={value}
                                pt={InputNumberPague}
                                onValueChange={(e) => onChange(e)}
                                onBlur={onBlur}
                                locale='pt-BR'
                                placeholder="ex: 981"
                                id="endereco_numero"
                                min={0}
                              />)}
                          />
                        </div>

                        <div className='grid w-full p-1'>
                          <label htmlFor="endereco_complemento">Complemento</label>
                          <InputText
                            {...register("endereco_complemento")}
                            placeholder="ex: em frente a Lotérica"
                            id="endereco_complemento"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {multipleDevedores && false && <div className="w-full">
                  <h6 className="text-align-center">Devedores Adicionados</h6>
                  <div className={`card border-1 border-blue-800`}>
                    {associados.map((devedor) => {
                      if (devedor.usuario_nome)
                        return (<>
                          <Chip
                            removable
                            removeIcon="pi pi-times"
                            key={devedor.devedor_documento}
                            label={devedor.usuario_nome}
                            style={{ backgroundColor: "midnightblue", color: "white" }}
                            onRemove={() => deleteDevedor(devedor.usuario_nome)}
                          />
                        </>
                        )
                    }
                    )}
                  </div>
                </div>}
                <div className="w-full flex items-center justify-center mt-4">
                  <Button
                    loading={loading}
                    pt={{
                      root: ({ context }) => ({
                        className: classNames(
                          'bg-pague_verde_claro hover:bg-pague_verde border-0',
                          'dark:bg-pague_verde dark:hover:bg-pague_verde_claro flex',
                          'p-4 rounded-lg text-white dark:text-black transition duration-200',
                          'items-center cursor-pointer inline-flex overflow-hidden relative select-none text-center align-bottom',
                          'transition duration-200 ease-in-out',
                          'focus:outline-none focus:outline-offset-0',
                          { 'opacity-60 pointer-events-none cursor-default': context.disabled }
                        )
                      }),
                      loadingIcon: ({ props }) => ({
                        className: classNames('mx-0', {
                          'mr-2': props.loading && props.iconPos == 'left' && props.label != null,
                          'ml-2 order-1': props.loading && props.iconPos == 'right' && props.label != null,
                          'mb-2': props.loading && props.iconPos == 'top' && props.label != null,
                          'mt-2 order-2': props.loading && props.iconPos == 'bottom' && props.label != null
                        })
                      }),
                    }}
                    className='w-1/3'
                    label="Enviar"
                    type="submit"
                  >
                  </Button>
                </div>
              </div>
            </form>
          </AppCard>
          <AppCard className='w-full'>
            <h4 className='text-2xl'>
              <b>Histórico de cobranças individuais geradas</b>
            </h4>
            <div className='mt-4 grid w-full overflow-auto'>
              <DataTable
                filterDisplay='menu'
                header={header}
                value={logInfo}
                rows={rows.current}
                currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                rowsPerPageOptions={[10, 20, 50]}
                onPage={onPage}
                pt={LargeTablePague}
                first={first.current}
                selection
                onSelectionChange={handleSelection}
                selectionMode="single"
                totalRecords={count}
                emptyMessage="Nenhuma cobrança adicionada manualmente desde 10/01/2024"
                paginator
                lazy
                loading={loadLog}
              >
                <Column header='Associado' field='associado_nome' body={(e) => { return e.associado_nome ? e.associado_nome : 'Acesso cliente' }} />
                <Column header='Data Geração' field='cobranca_create' body={(e) => { return format(new Date(e.cobranca_create), 'dd/MM/yyyy HH:mm:ss') }} />
                {/* <Column header='Devedor Documento' field='ls_othervalue' body={(e) => { return formatDocument(e.ls_othervalue) }} /> */}
                <Column field="cobranca_descricao" header="Descrição"></Column>
                <Column field="cobranca_valor" header="Valor Original" body={(e) => formatCurrency(e.cobranca_valor)}></Column>
                <Column field="data_vencimento_primeiro_boleto" header="Data de Vencimento" body={(rowData) => format(addHours(new Date(rowData.data_vencimento_primeiro_boleto), 3), 'dd/MM/yyyy')} />
              </DataTable>
            </div>
          </AppCard>
        </div>
        :
        <div className='w-full justify-center flex'>
          <AppCard>
            <h4><b>Gerar Cobrança</b></h4>
            <div>
              <h5>Adicione uma conta bancária para poder adicionar negociação individual
              </h5>
              <Button
                className='mt-4'
                icon={<FaArrowAltCircleRight className='text-xl mr-2' />}
                label="Ir para Configurações"
                onClick={() => navigate('/dashboard/configuracoes')} />
            </div>
          </AppCard>

        </div>}
    </>
  )
}
